/* global hbspt, scripts */

const initHubspotMultistepForms = () => {
    document.querySelectorAll('.js-hubspot-multistep-form').forEach($el => {
        new HubspotMultistepForm($el);
    });
};

/**
 * Gère plusieurs formulaires Hubspot qui
 * s'enchainent à la soumission du précédent
 * 
 * @param {HTMLElement}    $container  Hubspot forms Container
 * @param {integer}        portalId    Hubspot portal ID
 * @param {Array.<string>} formsId     Hubspot forms id
 * @param {string}         customClass Hubspot forms custom class
 * @param {Array}          data        Hubspot forms data
 * @param {Array}          options     Hubspot forms options
 */
class HubspotMultistepForm {
    constructor($container) {
        this.$container = $container;
        this.portalId = this.$container.dataset.portalId;
        this.formsId = this.$container.dataset.forms.split(',');

        this.customClass = this.$container.dataset.customClass || null;

        this.data = [];
        this.options = [];

        this.formsId.forEach((formId, step) => {
            this.options.push(this.generateFormOptions(formId, step));
        });
        hbspt.forms.create(this.options[0]);
    }

    /**
     * Création des options Hubspot
     * d'un formulaire à partir de son ID
     * 
     * @param {string}  formId Hubspot form ID
     * @param {integer} step   Step of the form
     * 
     * @return {void}
     */
    generateFormOptions(formId, step) {

        const $iframeContainer = document.querySelector('#' + this.$container.getAttribute('id'));
        
        return {
            portalId: this.portalId,
            formId,
            target: '#' + this.$container.getAttribute('id'),
            onFormReady: $form => {
                const $html = $form.closest('html').get(0);
                const $head = $html.querySelector('head');
                const $container = $html.querySelector('.hbspt-form');
                const linkTag = document.createElement('link');
                linkTag.rel = 'stylesheet';
                linkTag.href = scripts.css_url;
                $head.appendChild(linkTag);

                if (this.customClass) {
                    $container.classList.add(this.customClass);
                }
                
                setTimeout(function() {
                    $iframeContainer.querySelector('iframe').height = $html.scrollHeight;
                    $iframeContainer.querySelector('iframe').style.height = $html.scrollHeight+ 'px';
                }, 1500);
                
               
                if (step !== 0) {
                    $form.find('input[name="email"]').val(this.data[0].value).change();
                }
            },
            onFormSubmit: $form => {
                if (this.data.length === 0) {
                    this.data.push($form.serializeArray());
                }
            },
            onFormSubmitted: $form => {
                if (step !== this.formsId.length - 1) {
                    this.$container.innerHTML = '';
                    hbspt.forms.create(this.options[step + 1]);
                }
            },
        };
    }
}

export default initHubspotMultistepForms;
